import { customInviteActions } from '@lifesize/nucleus';
import { Dispatch } from 'redux';
import { MAILTO_MAX_LENGTH } from 'constants/Invite';
import { generateMailLink } from 'utils/invite-utils';

export const getInviteForExtension = (extension: string) => async (dispatch: Dispatch<any>) => {
  try {
    return await dispatch(customInviteActions.getExtensionInviteText(extension, 'email'));
  } catch (e) {
    return Promise.reject(JSON.stringify(e));
  }
};

export const getInviteMailLinkForExtension = (extension: string) => async (dispatch: Dispatch<any>) => {
  try {
    const fullInvite = await dispatch(customInviteActions.getExtensionInviteText(extension, 'email'));
    if (fullInvite.length < MAILTO_MAX_LENGTH) return generateMailLink(fullInvite);
    const previewInvite = await dispatch(customInviteActions.getExtensionInviteText(extension, 'shortEmail'));
    return generateMailLink(previewInvite);
  } catch (e) {
    return Promise.reject(JSON.stringify(e));
  }
};

export default { getInviteForExtension, getInviteMailLinkForExtension };
